$(function() {
    // Ajax params
    let myajax = `//${window.location.host}/wp-admin/admin-ajax.php`,
        paramObj = {
            action: 'load_events',
            postType: null,
            url: myajax,
            catId: 'all',
            paged: 1,
        };

    // Ajax helper function
    function loadEvents(paramObj) {
        $.ajax({
            url: paramObj.url,
            data: paramObj,
            type: 'POST',

            beforeSend() {
                $('.js-ajax-events-load').css({
                    'opacity': '.3',
                    'pointer-events': 'none'
                });
            },

            success(data) {
                $('.js-ajax-events-load').html(data);
            },

            complete() {
                $('.js-ajax-events-load').css({
                    'opacity': '1',
                    'pointer-events': 'auto'
                });
            }
        });
    }

    // Get city from URL
    function getCityFromUrl() {
        const params = new URLSearchParams(window.location.search);

        return params.get('city') || '';
    }

    // Update URL
    function updateUrl(citySlug) {
        const url = new URL(window.location.href);

        if (citySlug) {
            url.searchParams.set('city', citySlug);
        } else {
            url.searchParams.delete('city');
        }

        window.history.pushState({}, '', url);
    }

    // Load filter from URL
    function loadFilterFromUrl() {
        const citySlug = getCityFromUrl();

        let $filter;

        if (citySlug) {
            $filter = $('.js-load-event').filter(function() {
                return $(this).data('cat-slug') === citySlug;
            });
        } else {
            $filter = $('.js-load-event[data-cat-id="all"]');
        }

        if (!$filter.length) {
            return;
        }

        $('.js-load-event').removeClass('active');
        $filter.addClass('active');

        paramObj.catId = $filter.data('cat-id') || 'all';
        paramObj.postType = $filter.data('post-type');
        paramObj.paged = 1;

        loadEvents(paramObj);
    }

    // Filter
    $('body').on('click', '.js-load-event', function(e) {
        e.preventDefault();

        const $this = $(this),
            postType = $this.data('post-type'),
            catID = $this.data('cat-id'),
            citySlug = $this.data('cat-slug');

        if ($this.hasClass('active')) {
            return;
        }

        $('.js-load-event').removeClass('active');
        $this.addClass('active');

        paramObj.catId = catID ? catID : 'all';
        paramObj.postType = postType;
        paramObj.paged = 1;

        // Update URL
        updateUrl(citySlug);

        // Load events
        loadEvents(paramObj);
    });

    // Initial load
    loadFilterFromUrl();
});